( function( $, window, document ) {

    /*"use strict"; */ // Start of use strict

    var pluginName = "customSelect",
        defaults = {
            height: "450%"
        };

    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend( Plugin.prototype, {
        init: function() {

            var $this = $( this.element );

            $this.addClass('select-hidden');
            $this.wrap('<div class="select-wrapper"></div>');
            $this.after('<div class="select-styled"></div>');

            this.build();
        },
        build: function() {

            var $this = $( this.element );

            var $styledSelect = $this.next('.select-styled');
            $styledSelect.text($this.find('option:selected').eq(0).text());

            var $list = $('<ul />', {'class': 'select-options'}).insertAfter($styledSelect);
            var $l = $this.find('option, optgroup').length;

            for (var i = 0; i < $l; i++) {
                var tmp_text = ($this.find('option, optgroup').eq(i).attr('label') != undefined ? $this.find('option, optgroup').eq(i).attr('label') : $this.find('option, optgroup').eq(i).text());
                var tmp_rel = ($this.find('option, optgroup').eq(i).attr('label') != undefined ? 'optgroup' : $this.find('option, optgroup').eq(i).val());
                $('<li />', {
                    text: tmp_text,
                    rel: tmp_rel
                }).appendTo($list);
            }
            var $listItems = $list.children('li');

            $styledSelect.on('click', function( e ) {
                e.stopPropagation();
                var $styledOptions = $(this).next('ul.select-options');
                if ( $(this).hasClass('is-active') ) {
                    $(this).removeClass('is-active');
                    $styledOptions.removeClass('is-active');
                } else {
                    var $styledOptionsHeight = $(this).outerHeight() * 4.5;
                    $('.select-styled.is-active').not(this).each(function(){
                        $(this).removeClass('is-active');
                        $styledOptions.removeClass('is-active');
                    });

                    var $spaceToExpand = $(window).outerHeight() - ( $(this).offset().top - $(document).scrollTop() ) - $(this).outerHeight();

                    if ( $spaceToExpand < $styledOptionsHeight ) {
                        $(this).parent().addClass('is-inverted');
                    } else {
                        $(this).parent().removeClass('is-inverted');
                    }

                    $(this).addClass('is-active');
                    $styledOptions.addClass('is-active');
                }
            });

            $listItems.each( function() {
                $(this).on('click', function( e ) {
                    if($(this).attr('rel')!='optgroup'){
                        e.stopPropagation();
                        $styledSelect.text($(this).text()).removeClass('is-active');
                        $this.val($(this).attr('rel'));
                        $list.removeClass('is-active');
                        $this.eq($(this).index()).prop('selected',true);
                        $this.trigger('change');
                    }
                    else {
                        return false;
                    }
                });
            });

            $(document).click(function() {
                $styledSelect.removeClass('is-active');
                $list.removeClass('is-active');
            });
        },
        destroy: function() {

            var $this = $( this.element );

            $this.parent().find('.select-styled').remove();
            $this.parent().find('.select-options').remove();
            $this.unwrap();
            $this.removeClass('select-hidden is-hidden');
        },
        rebuild: function() {
            var $this = $( this.element );

            $this.parent().find('.select-styled').empty();
            $this.parent().find('.select-options').remove();
            this.build();
        },
        callFunction: function (call, options) {
            if(typeof this[call] === 'function') {
                return this[call](options);
            }
        }


    } );

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[ pluginName ] = function(call, options ) {
        return this.each( function() {
            if ( !$.data( this, "plugin_" + pluginName ) ) {
                $.data( this, "plugin_" + pluginName, new Plugin( this, options ) );
            } else {
                return $.data(this, "plugin_" + pluginName).callFunction(call, options);
            }
        } );
    };

    // $(document).on('ready domloaded ajaxloaded', function () {
    //     $(document).find('.gr-select').customSelect();
    // });

    $('.popup-preview').magnificPopup({
        type: 'image'
    });

} )( jQuery, window, document );
/*
* Tranform select menu into ul
*/
/*
$('.gr-select').each(function(){
    var $this = $(this), numberOfOptions = $(this).children('option').length;

    $this.addClass('select-hidden');
    $this.wrap('<div class="select"></div>');
    $this.after('<div class="select-styled"></div>');

    var $styledSelect = $this.next('div.select-styled');
    $styledSelect.text($this.children('option').eq(0).text());

    var $list = $('<ul />', {
        'class': 'select-options'
    }).insertAfter($styledSelect);

    for (var i = 0; i < numberOfOptions; i++) {
        $('<li />', {
            text: $this.children('option').eq(i).text(),
            rel: $this.children('option').eq(i).val()
        }).appendTo($list);
    }

    var $listItems = $list.children('li');

    $styledSelect.click(function(e) {
        e.stopPropagation();
        var $styledOptions = $(this).next('ul.select-options'),
            $styledOptionsHeight = 0;

        $('div.select-styled.is-active').not(this).each(function(){
            $(this).removeClass('is-active');
            $styledOptions.removeClass('is-active');
        });

        $listItems.each(function(){
            $styledOptionsHeight += $(this).outerHeight();
        });

        var $spaceToExpand = $(window).outerHeight() - ( $(this).offset().top - $(document).scrollTop() ) - $(this).outerHeight();

        if ( $spaceToExpand < $styledOptionsHeight ) {
            $(this).parent().toggleClass('is-inverted');
        } else {
            $(this).parent().removeClass('is-inverted');
        }

        $(this).toggleClass('is-active');
        $styledOptions.toggleClass('is-active');
    });

    $listItems.click(function(e) {
        e.stopPropagation();
        $styledSelect.text($(this).text()).removeClass('is-active');
        $this.val($(this).attr('rel'));
        $list.removeClass('is-active');
        $this.eq($(this).index()).prop('selected',true);
        $this.trigger('change');
    });

    $(document).click(function() {
        $styledSelect.removeClass('is-active');
        $list.removeClass('is-active');
    });

});*/

/*
* Custom Upload File
*/

// $('.file-upload--btn').each( function () {
//     var $this = $(this);
//     $('input[type=file]', $this).on('change', function () {
//         if($('input[type=file]', $this).val()!=='') {
//             $('label', $this).addClass('is-ready');
//         }
//     });
// });
//
// $('.file-upload--input').each( function () {
//     var $this = $(this);
//     $('input[type=file]', $this).on('change', function () {
//         if($('input[type=file]', $this).val()!=='') {
//             $('label', $this).html($('input[type=file]', $this).val()).addClass('is-ready');
//         }
//     });
// });


/*
* Parsley
*/

$("[data-parsley-validate]").length && $("[data-parsley-validate]").parsley({
    trigger:      'change',
    errorClass: "parsley-error",
    classHandler: function (el) {
        return el.$element.closest('.form-item, .form-item--inline');
    },
    errorsContainer: function(pEle) {
        var $err = pEle.$element.closest('.form-item').append();
        return $err;
    }
});